export const TOKEN_TYPE = 'Bearer '
export const REQUEST_REFRESH_TOKEN_URI = '/auth/refresh'
export const REQUEST_LOGIN_URI = '/auth/login'
export const UNAUTHORIZED_CODE = [401]
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
export const USER_REQUEST_HEADER_AUTH_KEY = 'uAuthorization'